<template>
  <div class="repair backdrop">
    <div class="repair-type">
      <div v-for="(repairtype, repairtype_key) in repairtype_list" :key="repairtype_key" :class="{active: curItem === repairtype_key}" @click="repairtypeClick(repairtype_key,repairtype.repair_type_id)">{{repairtype.repair_type_name}}</div>
    </div>
    <div class="common">
      <div class="repair-textarea">
        <textarea rows="6" placeholder="说明详细地址与报修内容，更有利于我们快速完成维修哦" v-model="repair_summary"></textarea>
      </div>
      <!-- 上传图片 -->
      <div class="uploadImg">
        <div class="uploadImgFile">
          <input class="uploadImg" @change="uploadFile" type="file">
        </div>
        <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
          <img class="img" :src="image" @click="previewImage(image)">
          <img class="del" @click="deleteImage(image_key)" src="../../assets/images/repairman-del.png">
        </div>
      </div>
      <!-- 预览图片 -->
      <div class="previewimg" v-if="previewFile">
        <div @click="previewclose"></div>
        <img :src="previewimg">
      </div>
    </div>
    <div class="common">
      <div class="cell-row" @click="SelectBuilding">
        <div class="row">报修房屋</div>
        <div class="row" :class="repair_house == '请选择报修房屋' ? 'gray':' '">{{repair_house}}</div>
      </div>
      <div class="cell-row">
        <div class="row">报事人<span class="mustred">*</span></div>
        <div class="row"><input type="text" placeholder="请输入报事人姓名" v-model="repair_people_name"></div>
      </div>
      <div class="cell-row">
        <div class="row">联系电话<span class="mustred">*</span></div>
        <div class="row"><input type="text" placeholder="请输入联系电话" v-model="repair_people_tel"></div>
      </div>
      <div class="cell-row">
        <div class="row">预约时间</div>
        <div class="row"><input type="text" placeholder="请选择预约时间" @click="selectData" v-model="date_time"></div>
        <mt-datetime-picker ref="datePicker" type="datetime" v-model="pickerValue" @confirm="handleConfirm"></mt-datetime-picker>
        <!-- <mt-datetime-picker ref="datePicker" type="datetime" v-model="pickerValue" year-format="{value}年" month-format="{value}月" date-format="{value}日" hour-format="{value}时" minute-format="{value}分" @confirm="handleConfirm"></mt-datetime-picker> -->
      </div>
      <div class="cell-row" @click="clickPosition">
        <div class="row">报修点定位</div>
        <div class="row gray" v-if="positionName == ''">请选择报修点定位</div>
        <div class="row" v-else>{{positionName}}</div>
      </div>
    </div>
    <div class="btn-submit">
      <button @click="submit">提交</button>
    </div>
    <v-map v-if="mapShow" @fatherMethod="fatherMethod"></v-map>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import BaiduMap from './BaiduMap'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Repair',
  metaInfo: {
    title: '报修中心'
  },
  components: {
    'v-map': BaiduMap
  },
  data () {
    return {
      loading: false, // 加载动画
      curItem: 0,
      repairtype_list: [],
      repair_type_id: '', // 报修分类id
      repair_summary: '', // 报修描述
      repair_people_name: '', // 报修联系人
      repair_people_tel: '', // 报修联系人电话
      date_time: '', // 报修预约时间
      pickerValue: new Date(),
      access_token: '', // tob access_token
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      mapShow: false,
      repair_house: '', // 报修房屋
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认关闭
      longitude: '',
      latitude: '',
      positionName: '',
      maxSize: 500, // 上传图片限制最大为500kb
      formData: '',
      imageStatus: true
    }
  },
  computed: {
    ...mapState(['userId', 'villageId', 'roomName', 'roomId', 'nickname', 'lng', 'lat', 'appid'])
  },
  created () {
    this.getRepairType()
    this.getAccessToken()

    this.repair_house = this.$route.query.roomname
    if (this.repair_house === undefined) {
      this.repair_house = '请选择报修房屋'
    }

    // 用getLocation自动获取当前位置的经纬度
    let that = this
    let url = window.location.href.split('#')[0]
    console.log(url)
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      console.log(res.data.data.appId)
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        console.log('成功')
        this.wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            // var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
            // var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
            // var speed = res.speed // 速度，以米/每秒计
            // var accuracy = res.accuracy // 位置精度
            that.changeArgs({lng: res.longitude, lat: res.latitude})
          }
        })
      })
      this.wx.error(function (res) {
        console.log('失败')
      })
    })
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        this.imageStatus = false
        let that = this
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = files.size / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              that.imageStatus = true
              console.log(that.imageListId)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    SelectBuilding () {
      this.$router.replace({name: 'SelectBuilding'})
    },
    // 获取报修类别
    getRepairType () {
      this.axios.get('/wechat/repair/getRepairType/village_id/' + this.villageId)
        .then((res) => {
          if (res.data.status === 1) {
            this.repairtype_list = res.data.data.data.repair_type_lists
            for (let i = 0; i < this.repairtype_list.length; i++) {
              this.repair_type_id = this.repairtype_list[0].repair_type_id
            }
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 选择报修类别
    repairtypeClick (key, repairtypeid) {
      this.curItem = key
      this.repair_type_id = repairtypeid
    },
    // 将时间戳转化为日期格式
    timestampToTime (timestamp) {
      var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = (date.getMonth() + 1)
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      // var s = date.getSeconds()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    // 获取当前时间
    getDate (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    // 打开时间选择器
    selectData () {
      this.$refs['datePicker'].open()
    },
    // 选择时间点击确定按钮
    handleConfirm (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      let resDate = year + '-' + month + '-' + day + ' ' + hour + ':' + minute
      this.date_time = resDate
    },
    // 子页面传回事件
    fatherMethod (data) {
      this.longitude = data.longitude
      this.latitude = data.latitude
      this.positionName = data.positionName
      this.mapShow = false
    },
    // 点击选择定位
    clickPosition () {
      this.mapShow = true
    },
    // 提交
    submit () {
      if (this.repair_summary === '') {
        this.$toast({
          message: '请输入报修描述',
          duration: 3000
        })
        return false
      }
      if (this.repair_people_name === '') {
        this.$toast({
          message: '请输入报事人',
          duration: 3000
        })
        return false
      }
      if (this.repair_people_tel === '') {
        this.$toast({
          message: '请输入报事人联系电话',
          duration: 3000
        })
        return false
      }
      if (this.imageStatus === false) {
        this.$toast({
          message: '图片未完成，请稍后再试',
          duration: 3000
        })
        return false
      }
      var date1 = new Date(this.date_time)
      console.log(date1)
      var date2 = new Date(this.getDate())
      var s1 = date1.getTime()
      console.log(s1)
      var s2 = date2.getTime()
      var total = s1 - s2
      console.log(total)
      if (total < 20 * 60 * 1000 && total !== 0) {
        this.$toast({
          message: '预约时间不能在报修时间20分钟内',
          duration: 3000
        })
        return false
      }
      this.loading = true
      this.axios.post('/wechat/repair/addRepair/', {
        village_id: this.villageId,
        user_id: this.userId,
        repair_summary: this.repair_summary,
        repair_people_name: this.repair_people_name,
        repair_people_tel: this.repair_people_tel,
        room_id: this.roomId,
        nickname: this.nickname,
        repair_type_id: this.repair_type_id,
        image_id: JSON.stringify(this.imageListId),
        order_time: this.date_time,
        longitude: this.longitude,
        latitude: this.latitude,
        local: this.positionName
      }).then((res) => {
        if (res.data.status === 1) {
          this.loading = false
          this.sendRepairTemp(res.data.data)
          this.$router.push({name: 'RepairCenter'})
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 发送模版消息
    sendRepairTemp (repairid) {
      this.axios.get('/wechat/index/sendRepairTemp/authorizer_appid/' + this.appid + '/village_id/' + this.villageId + '/repair_id/' + repairid).then((res) => {
        console.log(res)
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.repair-textarea {
  display: flex;
  margin-bottom: 5px;
}
.repair-textarea textarea {
  flex: 1;
  background-color: #f6f6f6;
  border: none;
  padding: 10px;
  outline: none;
  font-size: 15px;
}
.repair-type {
  padding: 0 15px;
  font-size: 16px;
  color: #313131;
  background-color: #ffffff;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow-x: auto;
}
.repair-type div {
  display: inline-block;
  padding-left: 15px;
  letter-spacing: 1px;
  line-height: 50px;
}
.repair-type div:first-child {
  padding-left: 0;
}
.repair-type .active {
  font-weight: bold;
  position: relative;
}
.repair-type .active::after {
  content: '';
  position: absolute;
  left: 40%;
  bottom: 16%;
  width: 20px;
  height: 3px;
  background-color: #ffaf14;
  border-radius: 5px;
}
.btn-submit {
  width: 100%;
  text-align: center;
  margin-top: 15px;
}
.btn-submit button {
  background-color: #ffffff;
  color: #000000;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  border: none;
  outline: initial;
  letter-spacing: 3px;
}
.gray {
  color: #8c8c8c;
}
input::-webkit-input-placeholder {
  color: #8c8c8c;
}
input::-moz-placeholder {
  color: #8c8c8c;
}
input:-moz-placeholder {
  color: #8c8c8c;
}
input:-ms-input-placeholder {
  color: #8c8c8c;
}
.mustred {
  margin-left: 3px;
  color: #ff0000 !important;
}
/* >>>
.picker-slot {
  font-size: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Repair/Repair.vue